import React from 'react';
import { Link } from 'react-router-dom';
import MarketingLayout from '../components/marketing/MarketingLayout';
import { GED_SUBJECTS } from '../data/siteContent';
import studentHero from '../assets/images/student-hero.png';

export default function ProgramPage() {
  return (
    <MarketingLayout>
      <header className="mk-page-hero">
        <div className="mk-container">
          <div className="mk-page-hero-grid">
            <div>
              <span className="mk-eyebrow">GED Program</span>
              <h1>Four subjects. One credential.</h1>
              <p>Lessons, an AI tutor, quizzes, and practice exams — unlocked with your study plan.</p>
              <div className="mk-inline-actions" style={{ marginTop: 20 }}>
                <Link to="/signup" className="mk-btn mk-btn-primary">
                  Enroll
                </Link>
                <Link to="/pricing" className="mk-btn mk-btn-secondary">
                  View plans
                </Link>
              </div>
            </div>
            <div className="mk-page-photo-card mk-page-photo-blue">
              <img src={studentHero} alt="Student preparing for the GED" />
              <div className="mk-page-photo-badge">
                <strong>4 subjects</strong>
                <small>Tutor, quizzes, exams</small>
              </div>
            </div>
          </div>
        </div>
      </header>

      <section className="mk-section">
        <div className="mk-container">
          <div className="mk-section-head">
            <span className="mk-eyebrow">Curriculum</span>
            <h2 className="mk-h2">What you study</h2>
          </div>
          <div className="mk-program-list">
            {GED_SUBJECTS.map((subject) => (
              <article key={subject.id} className="mk-program-row">
                <div className="mk-program-row-main">
                  <span className="mk-subject-icon" style={{ background: `${subject.color}14`, color: subject.color }}>
                    <span className="material-symbols-outlined">{subject.icon}</span>
                  </span>
                  <div>
                    <h3>{subject.title}</h3>
                    <p>{subject.short}</p>
                    <ul className="mk-chip-list">
                      {subject.topics.slice(0, 4).map((topic) => (
                        <li key={topic}>{topic}</li>
                      ))}
                    </ul>
                  </div>
                </div>
                <Link to={`/program/${subject.slug}`} className="mk-btn mk-btn-secondary">
                  View subject
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>
    </MarketingLayout>
  );
}
